import * as React from 'react';

import classNames from 'classnames';

import * as s from './BurgerButton.scss';

interface IBurgerButtonProps {
	onClick?(): void;
	isBackState?: boolean;
	className?: string;
	customColor?: string;
}

export const BurgerButton: React.FunctionComponent<IBurgerButtonProps> = (props: IBurgerButtonProps) => {
	const {
		onClick,
		isBackState,
		className,
		customColor,
	} = props;
	const [burgerClass, setBurgerClass] = React.useState(classNames(
		className,
		s.block,
	));
	const customStyle = {
		backgroundColor: customColor,
	};

	React.useEffect(() => {
		const burgerClassProp = classNames(
			className,
			s.block,
			{ [s.isBackMode]: isBackState },
		);

		setBurgerClass(burgerClassProp);
	}, [isBackState, className]);

	return (
		<div
			className={burgerClass}
			onClick={onClick}
		>
			<>
				<span className={s.line} style={customStyle}/>
				<span className={s.line} style={customStyle}/>
				<span className={s.line} style={customStyle}/>
			</>
		</div>
	);
};
